import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, resolveComponent as _resolveComponent, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-1736d8b9"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { id: "header" }, [
  /*#__PURE__*/_createElementVNode("div", { id: "header-content" })
], -1))
const _hoisted_2 = { id: "home" }
const _hoisted_3 = { id: "home-content" }
const _hoisted_4 = {
  key: 0,
  class: "loading"
}
const _hoisted_5 = {
  key: 1,
  class: "error"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Brand = _resolveComponent("Brand")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _hoisted_1,
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        (_ctx.loading)
          ? (_openBlock(), _createElementBlock("div", _hoisted_4, " Loading... "))
          : _createCommentVNode("", true),
        (_ctx.error)
          ? (_openBlock(), _createElementBlock("div", _hoisted_5, _toDisplayString(_ctx.error), 1))
          : _createCommentVNode("", true),
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.brands, (brand) => {
          return (_openBlock(), _createBlock(_component_Brand, {
            key: brand.id,
            brand: brand
          }, null, 8, ["brand"]))
        }), 128))
      ])
    ])
  ], 64))
}